import axios from 'axios';

export default class GenomicsDataAccessor {
  constructor(environment, listOfCategories) {
    this.isDev = (environment === "development")
    this.listOfCategories = listOfCategories
  }

  getGenomicsDataAndGiveToConsumer(consumerFunction) {
    if (this.isDev) {
      this.getResultFromUrlAndGiveToConsumerDEV(consumerFunction)
    } else {
      this.getResultFromUrlAndGiveToConsumer(consumerFunction)
    }
  }

  parseCSVToJsonAndGiveToConsumer(csvString, consumerFunction) {
  	const csv=require('csvtojson')

    const listOfCategories = this.listOfCategories // must pull this info into a var scoped to this function because 'this' will not work inside of the lambda below

    csv({
        noheader:false,
        output: "json",
        checkType:true,
    })
    .fromString(csvString)
    .then((listOfGenes)=>{
      consumerFunction(listOfGenes)
    })
  }

  getResultFromUrlAndGiveToConsumer(consumerFunction) {
    axios.get(`/mouse_and_rat_log2_cpm.csv`)
      .then(res => {
        this.parseCSVToJsonAndGiveToConsumer(res.data, consumerFunction)
      }).catch((error) => {
      	// pass on error handling for now
    });
  }

  getResultFromUrlAndGiveToConsumerDEV(consumerFunction) {
    var slimData = `gene_name,Mouse_Achilles_1,Mouse_Achilles_2,Mouse_Achilles_3,Mouse_Achilles_4,Mouse_Patellar_1,Mouse_Patellar_2,Mouse_Patellar_3,Mouse_Patellar_4,Mouse_ForepawFlexors_1,Mouse_ForepawFlexors_2,Mouse_ForepawFlexors_3,Mouse_ForepawFlexors_4,Mouse_Supra_1,Mouse_Supra_2,Mouse_Supra_3,Mouse_Supra_4,Rat_Achilles_1,Rat_Achilles_2,Rat_Achilles_3,Rat_Achilles_4,Rat_Patellar_1,Rat_Patellar_2,Rat_Patellar_3,Rat_Patellar_4,Rat_ForepawFlexors_1,Rat_ForepawFlexors_2,Rat_ForepawFlexors_3,Rat_ForepawFlexors_4,Rat_Supra_1,Rat_Supra_2,Rat_Supra_3,Rat_Supra_4\nAaas,3.545573991,3.912503504,3.619300578,3.574040784,3.469708489,3.549979709,4.198112988,2.881275445,3.842783405,4.033148224,3.734100112,4.167180642,4.094925901,4.16535825,4.3756625,3.907718442,4.188567075,4.170520258,4.207241142,4.339883475,3.685989613,3.662997056,3.758849931,4.010712762,3.447178726,3.644613345,3.752403695,3.503281472,3.745223769,3.760702474,3.957393255,3.78917852\nAacs,6.22996333,6.128859293,5.230418242,6.637439101,5.910405535,7.302290909,6.864262475,6.601819565,5.192989702,5.244466947,4.92297294,5.679262768,5.082222774,4.782255894,5.350457871,5.895391851,5.085946296,5.245176568,5.163948262,4.545999239,4.427588434,5.450836605,5.446582377,4.572217498,4.034317497,4.163676539,4.197481397,4.120512703,4.452112394,4.388726163,4.579468286,4.091331785\nZscan2,,,,,,,,,,,,,,,,,1.65544683,1.56868859,1.935625895,1.795604691,2.471834571,1.99306796,1.703986362,2.407056613,1.368521881,1.259448792,1.010973905,0.622911326,1.198009286,2.055718974,1.328001618,1.594245548\nGm40309,2.677880547,2.91761093,2.950463877,2.666491329,3.605075594,3.276895964,3.101755748,3.690846299,2.796364866,2.753407384,2.863967789,2.840014212,2.493082621,2.317566371,2.2654002,2.173153337,,,,,,,,,,,,,,,,\n5730419F03Rik,1.536575834,1.41066195,2.30383169,1.314115233,-2.11390771,-8.42162792,-4.641455916,-4.954138993,-0.037266622,0.690879262,0.254147534,0.222625413,-0.875293608,-1.347690304,-1.337778004,-0.837812795,,,,,,,,,,,,,,,,`
    this.parseCSVToJsonAndGiveToConsumer(slimData, consumerFunction)
  }
}